import React, { useState } from 'react';

  

function Form() {
    const [errors, setErrors] = useState(
        {
            firstname: '',
            lastname: '',
            email: '',
            password: ''
        }
    );

    const handleSubmit = (e) => {
        e.preventDefault();

        //Validation
        let newErrors = {
            firstname: '',
            lastname: '',
            email: '',
            password: ''
        };

        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

        if (!e.target.firstname.value.trim()) {
            newErrors.firstname = 'First name cannot be empty';

        }

        if (!e.target.lastname.value.trim()) {
            newErrors.lastname = 'Last Name cannot be empty';
        }

        if (!e.target.Email.value.trim() || !emailRegex.test(e.target.Email.value)) {
            newErrors.email = 'Looks like this is not an email';
        }

        if (e.target.password.value.length < 4) {
            newErrors.password = 'Password cannot be empty';
        }

        setErrors(newErrors);

        // If no errors, process form datea
        if (!newErrors.firstname && !newErrors.lastname && !newErrors.email && !newErrors.password) {

            console.log('Form submitted');
            alert("Form submitted sucessfully")

        }
    };

    return (
        <section>
            <p className='blue-background'>Try it free 7 days <span>then $20/mo. thereafter</span></p>

            <form onSubmit={handleSubmit}>
                <input 
                    type="text" 
                    name="firstname" 
                    id="firstname" 
                    placeholder="First Name"
                    className={errors.firstname ? 'input-error' : ''}
                />
                <p id='invalid-fname' className="error-text">{errors.firstname}</p>

                <input 
                    type="text" 
                    name="lastname" 
                    id="lastname" 
                    placeholder="Last Name"
                    className={errors.lastname ? 'input-error' : ''}
                />
                <p id='invalid-lname' className="error-text">{errors.lastname}</p>

                <input 
                    type="email" 
                    name="Email" 
                    id="Email" 
                    placeholder={errors.email ? 'email@example.com' : 'Email Address'}
                    className={errors.email ? 'input-error' : ''}
                />
                <p id='invalid-email' className="error-text">{errors.email}</p>

                <input 
                    type="password" 
                    name="password" 
                    id="password" 
                    placeholder="Password"
                    className={errors.password ? 'input-error' : ''}
                />
                <p id='invalid-password' className="error-text">{errors.password}</p>

                <input type="submit" value="Claim your free trial" className='green-background' />
                <p className='p-text'>By clicking the button, you are agreeing to our <span>Terms and Services</span></p>
                
            </form>
        </section>
    );
}

export default Form;